import SyLoadingIcon from "./sy-loading-icon";

export default SyLoadingIcon